import React from 'react';
import { CommaListField } from '../../inputs';

export default function SystemTagsField({
  tags,
  onChange,
  labelStyle,
  inputStyle,
}) {
  return (
    <CommaListField
      label={<span style={labelStyle}>Tags (comma separated)</span>}
      style={{ ...inputStyle, marginBottom: 0 }}
      value={tags || []}
      onChange={onChange}
      placeholder="horror, corruption, mystery"
      unmountPolicy="flush"
    />
  );
}
